<div class="w-full p-10">
	<div class="">
		<app-back-to-integrations-button></app-back-to-integrations-button>
	</div>

	<div class="flex gap-8 py-6">
		<div
			class="w-48 h-48 flex-shrink-0 p-6 rounded-lg bg-gray-100 flex items-center justify-center"
		>
			<img
				class="max-w-[120px]"
				src="/assets/images/integrations/sync-logo.png"
			/>
		</div>

		<div class="w-full">
			<div class="flex gap-x-2 items-center pb-4">
				<i-tabler
					[name]="isSyncIntegrationConnected ? 'user-filled' : 'user'"
					[ngClass]="isSyncIntegrationConnected ? 'text-green' : 'text-grey'"
				/>
				<h5
					class="h5"
					[ngClass]="
						isSyncIntegrationConnected ? 'text-gray-800' : 'text-gray-500'
					"
				>
					{{ syncLawyersRatio }}
				</h5>
			</div>
			<ui-content-header
				type="page"
				title="Sync by Closer"
				[subtitle]="closerSyncDescription"
			/>
			<div class="flex flex-col gap-2">
				<div *ngFor="let b of benefits" class="flex gap-2 items-center">
					<i-tabler name="check" class="text-tealGreen-500"></i-tabler>
					<span class="p-sm">{{ b }}</span>
				</div>
			</div>
		</div>
	</div>
	<!-- <ui-note callToActionType="CLOSE" closableId="lender-status-actions-required" class="w-full"
		title="Lender Status: Actions Required" type="warning" *ngIf="(vm$ | async).doesAnyUserHaveActionsRequired">
		<p class="p">
			What does the "Actions Required" Lender Status mean?
		</p>
		<p class="p-sm">
			{{lendersWithActionsRequired.length}} of Your Lenders require additional consent to transition their
			mortgage instructions to Sync. Read below to determine next steps for each lender.
		</p>

		<ul class="list-disc p-sm list-inside space-y-2 pt-2">
			<li *ngFor="let lender of lendersWithActionsRequired">
				{{lender.institutionName}}
			</li>
		</ul>
	</ui-note> -->
	<div class="flex flex-col gap-8">
		<ng-container>
			<div
				class="border border-gray-200 rounded-xl bg-white overflow-hidden"
				*ngIf="vm$ | async as vm; else noneConnected"
			>
				<table mat-table [dataSource]="vm.connectedUsers" class="w-full">
					<!-- name -->
					<ng-container matColumnDef="name">
						<th mat-header-cell *matHeaderCellDef>Account Holder</th>
						<td mat-cell *matCellDef="let element">
							<p class="text-sm text-gray-700">{{ element.name }}</p>
						</td>
					</ng-container>

					<!-- status -->
					<ng-container matColumnDef="status">
						<th mat-header-cell *matHeaderCellDef>Integration Status</th>
						<td mat-cell *matCellDef="let element">
							<div class="flex items-center gap-2">
								<div class="flex gap-x-2">
									<ui-status [status]="element?.syncStatus" />
									<app-anchor
										*ngIf="
											element?.syncStatus === STATUSES.CONNECTED &&
											(currentUser$ | async).id === element.userId
										"
										type="static"
										(click)="openHelpDrawer()"
										>Need Help Uploading Instructions?</app-anchor
									>
								</div>

								<ui-button
									(click)="openDisconnectAssystDrawer(element.user)"
									*ngIf="
										element?.syncStatus === STATUSES.ACTIONS_REQUIRED &&
										(currentUser$ | async).id === element.userId
									"
									preset="LOW_EMPHASIS"
									size="sm"
									label="Learn More"
								></ui-button>
							</div>
						</td>
					</ng-container>

					<!-- Lenders | TODO: add back in when ready -->
					<!-- <ng-container matColumnDef="lenders">
						<th mat-header-cell *matHeaderCellDef>Lenders Status</th>
						<td mat-cell *matCellDef="let element">
							<div class="flex gap-2 py-4">
								<div class="flex flex-col gap-2 w-full" *ngIf="element?.user?.status === STATUSES.CONNECTED">

									<div class="flex gap-2 items-center"
										*ngIf="element?.lenders?.numOfDisconnectedLenders as disconnectedLenders">
										<div class="px-2 py-0.5 rounded bg-gray-50 p-sm min-w-[92px] text-center">
											{{disconnectedLenders}} Lender<span *ngIf="disconnectedLenders > 1">s</span>
										</div>
										<ui-status [status]="STATUSES.DISCONNECTED"></ui-status>
									</div>

									<div class="flex gap-2 items-center"
										*ngIf="element?.lenders?.numOfRequestDisconnectLenders as requestDisconnectLenders">
										<div class="px-2 py-0.5 rounded bg-gray-50 p-sm min-w-[92px] text-center">{{
											requestDisconnectLenders }} Lender<span
												*ngIf="requestDisconnectLenders > 1">s</span></div>
										<ui-status [status]="STATUSES.REQUEST_DISCONNECT"></ui-status>
									</div>

									<div class="flex gap-2 items-center"
										*ngIf="element?.lenders?.numOfContactingLenders as contactingLenders">
										<div class="px-2 py-0.5 rounded bg-gray-50 p-sm min-w-[92px] text-center">{{
											contactingLenders }} Lender<span *ngIf="contactingLenders > 1">s</span>
										</div>
										<ui-status [status]="STATUSES.CONTACTING_LENDER"></ui-status>
									</div>

									<div class="flex gap-2 items-center"
										*ngIf="element?.lenders?.numOfActionsRequiredLenders as actionsRequiredLenders">
										<div class="px-2 py-0.5 rounded bg-gray-50 p-sm min-w-[92px] text-center">{{
											actionsRequiredLenders }} Lender<span
												*ngIf="actionsRequiredLenders > 1">s</span></div>
										<ui-status [status]="STATUSES.ACTIONS_REQUIRED"></ui-status>
										<button class="underline text-green-light"
											(click)="openActionsRequiredDrawer(element?.user)">Learn
											More</button>
									</div>

									<div class="flex gap-2 items-center"
										*ngIf="element?.lenders?.numOfConnectedLenders as connectedLenders">
										<div class="px-2 py-0.5 rounded bg-gray-50 p-sm min-w-[92px] text-center">{{
											connectedLenders }} Lender<span *ngIf="connectedLenders > 1">s</span></div>
										<ui-status [status]="STATUSES.CONNECTED"></ui-status>
									</div>

								</div>
							</div>
						</td>
					</ng-container> -->

					<!-- action -->
					<ng-container matColumnDef="action">
						<th mat-header-cell *matHeaderCellDef>Actions</th>
						<td mat-cell *matCellDef="let element">
							<div class="flex flex-1 items-center justify-end gap-2">
								<div
									*ngIf="
										element.syncStatus === STATUSES.CONNECTED;
										else notConnected
									"
								>
									<ui-button
										*ngIf="element?.user.id === vm.currentUser?.id"
										[disabled]="disableDrawerButton(element.user)"
										label="Settings"
										icon="settings"
										[style]="'ghost'"
										color="gray"
										(click)="openLendersDrawer(element.user)"
									/>
								</div>
								<ng-template #notConnected>
									<ui-button
										*ngIf="element?.user.id === vm.currentUser?.id"
										[label]="
											element.syncStatus === STATUSES.ACTIONS_REQUIRED
												? 'Verify Instructions Source'
												: 'Connect'
										"
										icon="bolt"
										preset="HIGH_EMPHASIS"
										(click)="connect(element.user, element.syncStatus)"
									/>
									<ui-button
										*ngIf="element?.user.id !== vm.currentUser?.id"
										[preset]="
											element?.user?.syncInviteReceived
												? 'EXTRA_LOW_EMPHASIS'
												: 'MEDIUM_EMPHASIS'
										"
										[label]="
											element?.user?.syncInviteReceived
												? 'Resend Invite'
												: 'Invite'
										"
										[icon]="
											element?.user?.syncInviteReceived ? 'refresh' : 'send'
										"
										(click)="connect(element.user, element.syncStatus)"
									/>
								</ng-template>

								<!-- <ui-dropdown alignment="right" direction="up" interaction="click">
									<ui-button dropdown-trigger
										*ngIf="element?.user.id === currentUser.id && element.syncStatus === STATUSES.CONNECTED"
										label="Disconnect" icon="plug-off" color="error" [style]="'outline'" />
									<div dropdown-content>
										<ui-button label="Yes, disconnect" icon="plug-off" color="error"
											(click)="disconnect()" />
									</div>
								</ui-dropdown> -->
							</div>
						</td>
					</ng-container>

					<tr
						mat-header-row
						*matHeaderRowDef="displayedColumns"
						class="bg-gray-50"
					></tr>
					<tr
						mat-row
						*matRowDef="let row; columns: displayedColumns"
						class="bg-white"
					></tr>
				</table>
			</div>
		</ng-container>

		<ng-template #noneConnected>
			<app-button (click)="connect()" size="small">Connect</app-button>
		</ng-template>

		<div class="grid grid-cols-12 w-full gap-8">
			<ui-section [uiColSpan]="6" title="Resources">
				<a
					section-content
					class="flex gap-2 items-center cursor-pointer p-sm"
					externalNavInterceptor
					href="https://www.closer.ca/sync"
					target="_blank"
				>
					<i-tabler
						name="external-link"
						class="h-4 w-4 text-tealGreen-500"
					></i-tabler>
					<span class="text-tealGreen-500 hover:underline duration-300"
						>New to Sync? Learn more</span
					>
				</a>
			</ui-section>
		</div>
	</div>
	<mat-drawer-container
		[hasBackdrop]="true"
		class="fixed h-screen w-full z-modal top-0 right-0"
		[ngClass]="{ 'pointer-events-none': isFullyClosed }"
	>
		<mat-drawer
			#drawer
			mode="over"
			position="end"
			(openStart)="openDrawer()"
			(closedStart)="closeDrawer()"
		>
			<ng-container *ngIf="!isFullyClosed">
				<div
					[ngSwitch]="(vm$ | async).currentDrawerView"
					class="p-6 max-w-[720px] h-full"
				>
					<app-closer-sync-settings-drawer
						*ngSwitchCase="CLOSER_SYNC_DRAWER_VIEW.SETTINGS"
						(closeDrawer)="closeInstitutionsDrawer($event)"
						[currentUserId]="(vm$ | async).currentUser?.id"
					></app-closer-sync-settings-drawer>
					<app-actions-required
						[renderBackButton]="
							(vm$ | async).shouldRenderActionsRequiredBackButton
						"
						*ngSwitchCase="CLOSER_SYNC_DRAWER_VIEW.ACTIONS_REQUIRED"
						(closeDrawer)="closeInstitutionsDrawer($event)"
					></app-actions-required>
					<app-disconnect-assyst
						*ngSwitchCase="CLOSER_SYNC_DRAWER_VIEW.DISCONNECT_ASSYST"
						(closeDrawer)="closeInstitutionsDrawer($event)"
						[showSyncSuccessState]="showSyncSuccessState"
					></app-disconnect-assyst>
					<p *ngSwitchDefault>
						Uh OH! The drawer you are trying to open does not exist
					</p>
				</div>
			</ng-container>
		</mat-drawer>
	</mat-drawer-container>
</div>
